import React from 'react';
import '../styles/StartupLanding.css';

const StartupFooter = () => {
    return (
        <footer className="startup-footer">
            <div className="footer-content">
                <div className="footer-left">
                    © {new Date().getFullYear()} MoveFlair
                </div>
                <div className="footer-right">
                    <a href="mailto:hello@moveflair.com">Contact</a>
                </div>
            </div>
        </footer>
    );
};

export default StartupFooter;